// 营销邮件管理 (FBMPLAY-1231) i18n — 6 个命名空间合并
export default {
  emailSenders: {
    tab: { senders: 'Remitentes' },
    title: 'Gestión de Remitentes de Correo',

    // Query form
    form: {
      channelEmpty: 'Todavía no hay dominios de envío, agregue uno en Dominio de envío / Canal',
      bussType: 'Tipo de Negocio',
      bussTypePlaceholder: 'Seleccione tipo de negocio',
      channel: 'Canal',
      channelPlaceholder: 'Seleccione canal',
      fromEmail: 'Correo del Remitente',
      fromEmailPlaceholder: 'Ingrese correo del remitente',
      fromEmailPrefixPlaceholder: 'Ingrese la parte antes de @',
      domainPending: 'Seleccione primero un dominio de envío',
      fromName: 'Nombre del Remitente',
      fromNamePlaceholder: 'Ingrese nombre del remitente',
      status: 'Estado',
      statusPlaceholder: 'Seleccione estado'
    },

    // Table columns
    table: {
      index: 'Nº',
      fromName: 'Nombre del Remitente',
      bussType: 'Tipo de Negocio',
      fromEmail: 'Correo del Remitente',
      channel: 'Canal',
      lastOperator: 'Última Operación / Hora',
      status: 'Estado',
      actions: 'Acciones'
    },

    // Business type
    bussType: {
      marketing: 'Marketing',
      notification: 'Notificación'
    },

    // Channel
    channel: {
      notConfigured: 'Sin dominio',
      mailgunApi: 'Mailgun API'
    },

    // Status
    status: {
      enabled: 'Habilitado',
      disabled: 'Deshabilitado'
    },

    // Buttons
    button: {
      search: 'Buscar',
      reset: 'Restablecer',
      create: 'Añadir',
      edit: 'Editar',
      delete: 'Eliminar'
    },

    // Modal
    modal: {
      createTitle: 'Añadir Remitente',
      editTitle: 'Editar Remitente'
    },

    // Validation
    validation: {
      domainMismatch: 'El dominio del From Email ({{emailDomain}}) no coincide con el dominio de envío seleccionado ({{channelDomain}})',
      domainNotConfigured: 'El dominio {{domain}} aún no tiene canal / key configurado, agréguelo en Dominio de envío / Canal',
      bussTypeRequired: 'Seleccione tipo de negocio',
      channelRequired: 'Seleccione canal',
      fromEmailRequired: 'Ingrese correo del remitente',
      fromEmailInvalid: 'Ingrese una dirección de correo válida',
      fromEmailPrefixRequired: 'Ingrese el prefijo del buzón',
      fromEmailPrefixInvalid: 'El prefijo solo puede contener letras, dígitos y símbolos comunes como . _ - +',
      fromNameRequired: 'Ingrese nombre del remitente',
      statusRequired: 'Seleccione estado'
    },

    // Confirm
    confirm: {
      enable: '¿Está seguro de que desea habilitar este remitente?',
      disable: '¿Está seguro de que desea deshabilitar este remitente?',
      delete: '¿Está seguro de que desea eliminar este remitente?',
      okText: 'Aceptar',
      cancelText: 'Cancelar'
    },

    // Messages
    message: {
      queryFailed: 'Error en la consulta',
      createSuccess: 'Creado exitosamente',
      createFailed: 'Error al crear',
      updateSuccess: 'Actualizado exitosamente',
      updateFailed: 'Error al actualizar',
      deleteSuccess: 'Eliminado exitosamente',
      deleteFailed: 'Error al eliminar',
      statusUpdateSuccess: 'Estado actualizado exitosamente',
      statusUpdateFailed: 'Error al actualizar el estado'
    }
  },
  emailTemplates: {
    title: 'Plantillas de Correo',

    loadingMore: 'Cargando...',
    copySuffix: '-Copia',

    // Form
    form: {
      tempName: 'Nombre de Plantilla',
      tempNamePlaceholder: 'Ingrese nombre de plantilla',
      country: 'Región',
      countryPlaceholder: 'Seleccione región',
      category: 'Categoría',
      categoryPlaceholder: 'Seleccione categoría',
      bussType: 'Tipo de Negocio',
      bussTypePlaceholder: 'Seleccione tipo de negocio',
      fromEmail: 'Remitente',
      fromEmailPlaceholder: 'Seleccione remitente',
      tempTitle: 'Asunto del Correo',
      tempTitlePlaceholder: 'Ingrese asunto del correo',
      status: 'Estado',
      statusPlaceholder: 'Seleccione estado',
      content: 'Cuerpo del Correo',
      contentPlaceholder: 'Ingrese cuerpo del correo (se admite HTML). Variable: {{memberAccount}}'
    },

    bussType: {
      marketing: 'Marketing',
      notification: 'Notificación'
    },

    table: {
      tempId: 'ID de Plantilla',
      tempName: 'Nombre de Plantilla',
      bussType: 'Tipo',
      country: 'Región',
      category: 'Categoría',
      tempTitle: 'Asunto del Correo',
      lastOperate: 'Última Operación / Hora',
      status: 'Estado',
      actions: 'Acciones'
    },

    status: {
      enabled: 'Habilitado',
      disabled: 'Deshabilitado'
    },

    button: {
      create: 'Nueva Plantilla',
      copy: 'Copiar',
      test: 'Envío de Prueba'
    },

    modal: {
      createTitle: 'Nueva Plantilla de Correo',
      editTitle: 'Editar Plantilla de Correo'
    },

    variables: {
      example: 'ej.',
      group: { COMMON: 'General', TRANSACTION: 'Transacción', ACTIVITY: 'Promoción' },
      title: 'Variables Soportadas',
      tip: 'Haga clic en una variable para insertarla en el cuerpo del correo',
      memberAccount: 'Cuenta de Miembro'
    },

    validation: {
      tempNameRequired: 'Ingrese nombre de plantilla',
      countryRequired: 'Seleccione región',
      categoryRequired: 'Seleccione categoría',
      bussTypeRequired: 'Seleccione tipo de negocio',
      fromEmailRequired: 'Seleccione remitente',
      tempTitleRequired: 'Ingrese asunto del correo',
      contentRequired: 'Ingrese cuerpo del correo',
      statusRequired: 'Seleccione estado'
    },

    message: {
      queryFailed: 'Error en la consulta',
      createSuccess: 'Creado exitosamente',
      createFailed: 'Error al crear',
      updateSuccess: 'Actualizado exitosamente',
      updateFailed: 'Error al actualizar',
      deleteSuccess: 'Eliminado exitosamente',
      deleteFailed: 'Error al eliminar',
      copySuccess: 'Copiado exitosamente',
      copyFailed: 'Error al copiar',
      statusUpdateSuccess: 'Estado actualizado exitosamente',
      statusUpdateFailed: 'Error al actualizar el estado'
    },

    confirm: {
      delete: '¿Está seguro de que desea eliminar esta plantilla?',
      toggleStatus: '¿Está seguro de que desea cambiar el estado de esta plantilla?'
    },

    pagination: {
      total: 'Total {{total}} registros'
    },

    test: {
      title: 'Envío de Prueba de Correo',
      templateName: 'Nombre de Plantilla',
      templateTitle: 'Asunto del Correo',
      templateContent: 'Cuerpo del Correo',
      inputLabel: 'Destinatario',
      inputPlaceholder: 'Ingrese dirección de correo o cuenta de miembro',
      inputHint: 'El sistema detectará automáticamente si la entrada es una dirección de correo o una cuenta de miembro',
      send: 'Enviar',
      inputRequired: 'Ingrese dirección de correo o cuenta de miembro',
      success: 'Envío de prueba exitoso',
      failed: 'Error en envío de prueba',
      error: 'Error de envío de prueba',
      userNotFound: 'Usuario de prueba no encontrado en el sistema'
    },

    category: {
      modal: {
        title: 'Gestión de Categorías de Plantilla'
      },
      table: {
        id: 'ID',
        name: 'Nombre de Categoría',
        actions: 'Acciones'
      },
      form: {
        namePlaceholder: 'Ingrese nombre de categoría'
      },
      button: {
        create: 'Nueva Categoría'
      },
      confirm: {
        delete: '¿Está seguro de que desea eliminar esta categoría?',
        deleteDesc: 'Esta acción no se puede deshacer, proceda con cuidado'
      },
      allCategories: 'Todas las Categorías',
      nameRequired: 'Ingrese nombre de categoría',
      nameExists: 'El nombre de categoría ya existe',
      queryFailed: 'Error al consultar categorías',
      createSuccess: 'Categoría creada exitosamente',
      createFailed: 'Error al crear categoría',
      deleteSuccess: 'Categoría eliminada exitosamente',
      deleteFailed: 'Error al eliminar categoría'
    }
  },
  emailTasks: {
    title: 'Correo Masivo',

    button: {
      createInternalCampaign: 'Nueva Campaña de Usuario Interno',
      createExternalCampaign: 'Nueva Campaña de Usuario Externo',
      view: 'Ver',
      edit: 'Editar',
      delete: 'Eliminar',
      sendNow: 'Enviar Ahora',
      uploadFile: 'Subir Archivo',
      importLog: 'Registro de Importación',
      reset: 'Restablecer'
    },

    form: {
      taskName: 'Nombre de Tarea',
      taskNamePlaceholder: 'Ingrese nombre de tarea',
      operator: 'Operador',
      operatorPlaceholder: 'Ingrese operador',
      region: 'Región',
      regionPlaceholder: 'Seleccione región',
      status: 'Estado',
      statusPlaceholder: 'Seleccione estado',
      sendTime: 'Hora de Envío',
      mode: 'Modo',
      modeFilter: 'Envío Masivo (por filtro)',
      modeImport: 'Importar Nombres de Usuario (subir CSV)',
      category: 'Categoría',
      categoryPlaceholder: 'Seleccione categoría',
      template: 'Plantilla de Correo',
      templatePlaceholder: 'Seleccione plantilla de correo',
      agent: 'Nombre del Agente',
      agentPlaceholder: 'Seleccione agente',
      fromEmail: 'De',
      fromEmailPlaceholder: 'Se completa automáticamente después de seleccionar la plantilla',
      templateContent: 'Contenido de Plantilla',
      templateContentPlaceholder: 'Se completa automáticamente después de seleccionar la plantilla',
      trackStatus: 'Habilitar seguimiento de aperturas/clics',
      uploadEmailList: 'Subir Lista de Correos',
      chooseFile: 'Seleccionar Archivo',
      uploaded: 'Subido'
    },

    table: {
      taskName: 'Nombre de Tarea',
      template: 'Plantilla',
      region: 'Región',
      operator: 'Operador',
      createTime: 'Creado en',
      sendTime: 'Hora de Envío',
      actions: 'Acciones'
    },

    status: {
      pendingUpload: 'Pendiente de Subida de Lista',
      pendingSend: 'Pendiente de Envío',
      ready: 'Lista Lista',
      completed: 'Completado',
      sent: 'Enviado'
    },

    confirm: {
      delete: '¿Está seguro de que desea eliminar esta tarea?',
      send: '¿Está seguro de que desea enviar ahora?'
    },

    validation: {
      taskNameRequired: 'Ingrese nombre de tarea',
      regionRequired: 'Seleccione región',
      categoryRequired: 'Seleccione categoría',
      templateRequired: 'Seleccione plantilla de correo',
      agentRequired: 'Seleccione agente'
    },

    message: {
      queryFailed: 'Error en la consulta',
      createSuccess: 'Creado exitosamente',
      createFailed: 'Error al crear',
      updateSuccess: 'Actualizado exitosamente',
      updateFailed: 'Error al actualizar',
      deleteSuccess: 'Eliminado exitosamente',
      deleteFailed: 'Error al eliminar',
      sendSuccess: 'Enviado exitosamente',
      sendFailed: 'Error al enviar'
    },

    upload: {
      success: 'Subida exitosa',
      failed: 'Error en la subida',
      error: 'Error de subida: {error}',
      invalidFileType: 'Tipo de archivo no compatible, suba Excel o CSV',
      pleaseUploadFirst: 'Suba primero el archivo de lista'
    },

    modal: {
      createTitle: 'Nuevo Correo Masivo',
      editTitle: 'Editar Correo Masivo',
      viewTitle: 'Ver Correo Masivo',
      importLogTitle: 'Registro de Importación',
      close: 'Cerrar'
    },

    importLog: {
      result: { excluded: 'Excluido', failed: 'Fallido', excludedReason: 'Dado de baja, no se enviará' },
      loading: 'Cargando...',
      header: {
        taskName: 'Nombre de Tarea',
        operator: 'Operador',
        importFileName: 'Nombre de Archivo de Importación',
        importCompleteTime: 'Importación Completada en',
        importStatus: 'Estado de Importación'
      },
      stats: {
        excluded: 'Excluidos (baja)',
        success: 'Importado',
        failed: 'Error',
        total: 'Total'
      },
      failureDetails: {
        result: 'Resultado',
        title: 'Detalles de Error',
        target: 'Destinatario',
        failureReason: 'Motivo del Error',
        noFailedRecords: 'Sin registros fallidos',
        noImportRecords: 'Sin registros de importación aún'
      },
      uploadFileStatus: {
        '0': 'Procesando',
        '1': 'Completado',
        '2': 'Error'
      }
    },

    pagination: {
      total: 'Total {total}'
    }
  },
  emailLogs: {
    title: 'Registros de Envío de Correo',

    // Form related
    form: {
      sendTime: 'Hora de Envío',
      sendTimePlaceholder: 'Seleccione hora de envío',
      startDate: 'Fecha de Inicio',
      endDate: 'Fecha de Fin',
      region: 'Región',
      regionPlaceholder: 'Seleccione región',
      task: 'Nombre de Tarea',
      taskPlaceholder: 'Ingrese nombre de tarea',
      subTypePlaceholder: 'Seleccione subtipo / tipo de miembro',
      subTypeMemberGroup: 'Tipo de Miembro',
      taskType: 'Tipo de Envío',
      taskTypePlaceholder: 'Seleccione tipo de envío',
      bussType: 'Tipo de Negocio',
      bussTypePlaceholder: 'Seleccione tipo de negocio',
      account: 'Cuenta de Miembro / Correo',
      accountPlaceholder: 'Ingrese cuenta de miembro o correo',
      status: 'Estado',
      statusPlaceholder: 'Seleccione estado'
    },

    // Table related
    table: {
      time: 'Hora de Envío',
      task: 'Nombre de Tarea',
      region: 'Región',
      type: 'Tipo',
      user: 'Cuenta de Miembro',
      email: 'Correo',
      status: 'Estado',
      openTime: 'Abierto',
      remark: 'Motivo del Error'
    },

    // Business type
    type: {
      bulk: 'Masivo',
      ndc: 'Cliente Nuevo',
      inactive: 'Inactivo',
      churn: 'Cancelación',
      vip: 'VIP',
      welcome: 'Bienvenida',
      restorage: 'Redepósito'
    },

    // Status related
    status: {
      submitted: 'Enviado',
      accepted: 'Enviado',
      delivered: 'Entregado',
      opened: 'Abierto',
      failed: 'Error',
      unsubscribed: 'Desuscrito',
      complained: 'Queja',
      unknown: 'Desconocido'
    },

    // Export related
    export: {
      button: 'Exportar',
      loading: 'Tarea de exportación creada. Verifique el progreso en la lista de descargas.',
      noData: 'Sin datos para exportar',
      tooMany: 'Máximo 100.000 registros por exportación. Por favor, estreche sus filtros.'
    },

    // Message related
    message: {
      queryFailed: 'Error en la consulta',
      exportSuccess: 'Exportación exitosa',
      exportFailed: 'Error en la exportación'
    },

    // Pagination related
    pagination: {
      total: 'Total {{total}} registros'
    }
  },
  emailReport: {
    // Page title
    title: 'Informe de Envío',
    subtitle: 'Informe de estadísticas y análisis de envío de correo',

    // Form fields
    form: {
      startTime: 'Hora de Inicio',
      startTimeRequired: 'Seleccione hora de inicio',
      startTimePlaceholder: 'Seleccione hora de inicio',
      endTime: 'Hora de Fin',
      endTimeRequired: 'Seleccione hora de fin',
      endTimePlaceholder: 'Seleccione hora de fin',
      taskName: 'Nombre de Tarea',
      taskNamePlaceholder: 'Ingrese nombre de tarea',
      channel: 'Canal',
      channelPlaceholder: 'Seleccione canal',
      status: 'Estado',
      statusPlaceholder: 'Seleccione estado',
      region: 'Región',
      regionPlaceholder: 'Seleccione región'
    },

    // Task status
    status: {
      pending: 'Pendiente',
      sending: 'Enviando',
      completed: 'Completado'
    },

    // Channel
    channel: {
      mailgunApi: 'Mailgun API'
    },

    // Region
    region: {
      ph: 'PH - Filipinas',
      vn: 'VN - Vietnam',
      th: 'TH - Tailandia',
      cn: 'CN - China'
    },

    // Buttons
    button: {
      search: 'Buscar',
      reset: 'Restablecer',
      export: 'Exportar'
    },

    // Table columns
    table: {
      date: 'Fecha',
      task: 'Nombre de Tarea',
      targetCount: 'Objetivo',
      sendCount: 'Enviado',
      deliveredCount: 'Entregado',
      failedCount: 'Error',
      openedCount: 'Abierto',
      actions: 'Acciones',
      viewLogs: 'Ver Registros'
    },

    // Logs modal
    logs: {
      title: 'Registros de Envío',
      time: 'Hora',
      task: 'Tarea',
      user: 'Usuario',
      email: 'Correo',
      channel: 'Canal',
      status: 'Estado',
      remark: 'Observación',
      statusPending: 'Pendiente',
      statusSuccess: 'Éxito',
      statusFailed: 'Error',
      statusUnknown: 'Desconocido'
    },

    // Messages
    message: {
      selectTimeRange: 'Seleccione hora de inicio y fin',
      exportSuccess: 'Exportación exitosa',
      exportFailed: 'Error en la exportación',
      exporting: 'Exportando datos...',
      queryFailed: 'Error en la consulta',
      noData: 'Sin datos'
    },

    // Pagination
    pagination: {
      total: 'Total {total} registros'
    }
  },
  emailUnsubscribe: {
    title: 'Lista de Desuscripción',

    // Form / filters
    form: {
      unsubscribeTime: 'Hora de Desuscripción',
      startDate: 'Fecha de Inicio',
      endDate: 'Fecha de Fin',
      emailAddress: 'Dirección de Correo',
      emailAddressPlaceholder: 'Ingrese dirección de correo',
      memberAccount: 'Cuenta de Miembro',
      memberAccountPlaceholder: 'Ingrese cuenta de miembro',
      originType: 'Origen',
      originTypePlaceholder: 'Seleccione origen',
      reason: 'Motivo',
      reasonPlaceholder: 'Seleccione motivo',
      remark: 'Observación',
      remarkPlaceholder: 'Ingrese observación',
      search: 'Buscar',
      reset: 'Restablecer'
    },

    // Table
    table: {
      nonMember: 'No miembro',
      unsubscribeTime: 'Hora de Desuscripción',
      emailAddress: 'Dirección de Correo',
      memberAccount: 'Cuenta de Miembro',
      originType: 'Origen',
      remark: 'Observación',
      actions: 'Acciones'
    },

    // Origin type
    originType: {
      all: 'Todos',
      selfUnsubscribe: 'Autodesuscripción (Enlace)',
      complaint: 'Queja / Solicitud',
      manual: 'Añadido Manualmente por Soporte'
    },

    // Add modal
    add: {
      mode: 'Dar de baja por',
      modeMember: 'Cuenta de miembro',
      modeEmail: 'Correo electrónico',
      modeEmailHint: 'Para no miembros / quejas y otros casos de respaldo',
      lookupEmail: 'Buscar correo',
      validEmail: 'Correo verificado (autocompletado, enmascarado, solo lectura)',
      validEmailPlaceholder: 'Se completa al buscar la cuenta del miembro',
      button: 'Añadir Desuscripción',
      title: 'Añadir Desuscripción',
      okText: 'Aceptar',
      cancelText: 'Cancelar'
    },

    // Delete
    delete: {
      button: 'Eliminar',
      confirm: '¿Está seguro de que desea eliminar este registro de desuscripción?',
      okText: 'Aceptar',
      cancelText: 'Cancelar',
      complaintBlocked: 'Los registros de desuscripción por queja/solicitud no se pueden eliminar. Solo se pueden eliminar los registros añadidos manualmente por soporte.'
    },

    // Validation
    validation: {
      memberAccountRequired: 'Ingrese la cuenta del miembro',
      lookupFirst: 'Pulse "Buscar correo" para confirmar el correo verificado del miembro',
      emailAddressRequired: 'Ingrese dirección de correo',
      emailAddressInvalid: 'Ingrese una dirección de correo válida',
      reasonRequired: 'Seleccione motivo'
    },

    // Messages
    message: {
      lookupFailed: 'No se pudo buscar el correo del miembro',
      queryFailed: 'Error en la consulta',
      addSuccess: 'Añadido exitosamente',
      addFailed: 'Error al añadir',
      deleteSuccess: 'Eliminado exitosamente',
      deleteFailed: 'Error al eliminar'
    }
  },
  emailAutoPushConfig: {
    title: 'Configuración de Correo Automático',

    searchForm: {
      language: 'Idioma',
      languagePlaceholder: 'Seleccione idioma',
      bussType: 'Tipo de Negocio',
      bussTypePlaceholder: 'Seleccione tipo de negocio',
      aimType: 'Tipo de Objetivo',
      aimTypePlaceholder: 'Seleccione tipo de objetivo',
      subPushType: 'Subtipo',
      subPushTypePlaceholder: 'Seleccione subtipo',
      memberType: 'Tipo de Miembro',
      memberTypePlaceholder: 'Seleccione tipo de miembro',
      status: 'Estado',
      statusPlaceholder: 'Seleccione estado',
      search: 'Buscar',
      reset: 'Restablecer',
      add: 'Añadir Regla'
    },

    table: {
      language: 'Idioma',
      aimType: 'Tipo de Destino',
      subTypeOrMember: 'Subtipo / Tipo de Miembro',
      ruleName: 'Nombre de Regla',
      template: 'Plantilla',
      status: 'Estado',
      operation: 'Operación',
      edit: 'Editar'
    },

    aimType: {
      scene: 'Disparador de Escena',
      target: 'Usuario Objetivo'
    },

    pushSwitch: {
      enabled: 'Habilitado',
      disabled: 'Deshabilitado'
    },

    confirm: {
      enable: '¿Está seguro de que desea habilitar esta regla?',
      disable: '¿Está seguro de que desea deshabilitar esta regla?',
      okText: 'Confirmar',
      cancelText: 'Cancelar'
    },

    modal: {
      addTitle: 'Agregar Regla de Correo Automático',
      editTitle: 'Editar Regla de Correo Automático',
      baseInfoTitle: 'Información Básica',
      ruleName: 'Nombre de Regla',
      ruleNamePlaceholder: 'Ingrese el nombre de la regla',
      language: 'Idioma',
      languagePlaceholder: 'Seleccione el idioma',
      aimType: 'Tipo de Destino',
      pushType: 'Evento Disparador',
      pushTypePlaceholder: 'Seleccione el evento disparador',
      subPushType: 'Subtipo',
      subPushTypePlaceholder: 'Seleccione el subtipo',
      loginChannel: 'Canal de Inicio de Sesión',
      loginChannelPlaceholder: 'Seleccione el canal de inicio de sesión',
      memberType: 'Tipo de Miembro',
      memberTypePlaceholder: 'Seleccione el tipo de miembro',
      sendTime: 'Tiempo de Envío',
      sendTimePlaceholder: 'Ingrese el tiempo de envío',
      sendTimePlaceholderDay: 'Ingrese el número de días',
      sendTimePlaceholderWeek: 'Ingrese 1-7 (1=lunes, 7=domingo)',
      sendTimePlaceholderMonth: 'Ingrese 1-31 (día del mes)',
      sendTimeUnit: 'Unidad de Tiempo',
      status: 'Estado',
      enable: 'Habilitar',
      disable: 'Deshabilitar',
      emailContentTitle: 'Contenido del Correo',
      bussType: 'Tipo de Negocio',
      bussTypePlaceholder: 'Seleccione el tipo de negocio',
      tempClassify: 'Categoría de Plantilla',
      tempClassifyPlaceholder: 'Seleccione la categoría de plantilla',
      template: 'Seleccionar Plantilla',
      templatePlaceholder: 'Seleccione la plantilla',
      preview: {
        fromEmail: 'Correo del Remitente',
        tempTitle: 'Asunto del Correo',
        tempContent: 'Contenido del Correo'
      }
    },

    validation: {
      ruleNameRequired: 'Ingrese el nombre de la regla',
      languageRequired: 'Seleccione el idioma',
      subPushTypeRequired: 'Seleccione el subtipo',
      sendTimeRequired: 'Ingrese el tiempo de envío',
      sendTimeUnitRequired: 'Seleccione la unidad de tiempo',
      sendTimeRange: 'El tiempo de envío debe estar entre {{min}} y {{max}}',
      tempClassifyRequired: 'Seleccione la categoría de plantilla',
      templateRequired: 'Seleccione la plantilla',
      depositNumberRequired: 'Ingrese la orden de depósito'
    },

    messages: {
      fetchDataFailed: 'Error al obtener datos',
      addSuccess: 'Agregado exitosamente',
      addFailed: 'Error al agregar',
      updateSuccess: 'Actualizado exitosamente',
      updateFailed: 'Error al actualizar',
      confirmDelete: 'Confirmar eliminación',
      deleteSuccess: 'Eliminado exitosamente',
      deleteFailed: 'Error al eliminar',
      statusUpdateSuccess: 'Estado actualizado exitosamente',
      statusUpdateFailed: 'Error al actualizar el estado'
    }
  },
  // 发信域名 / 渠道（FBMPLAY-1595 多域名多 Key，发件人管理页 Admin-only Tab）
  emailChannels: {
    title: 'Dominio de envío / Canal',

    tab: {
      channels: 'Dominio de envío',
    },

    hint: {
      perDomainKey: 'Una Sending API Key por dominio (admite varias); los remitentes pertenecen a un dominio y comparten su key.'
    },

    table: {
      sendDomain: 'Dominio de envío',
      region: 'Region',
      apiKey: 'Sending API Key',
      apiKeyMissing: 'Sin configurar',
      status: 'Estado',
      lastOperator: 'Último operador / hora',
      actions: 'Acciones'
    },

    form: {
      sendDomain: 'Dominio de envío',
      sendDomainPlaceholder: 'ej. mail.newbrand.com',
      region: 'Region',
      apiKey: 'Sending API Key',
      apiKeyPlaceholder: 'Pegue la Mailgun sending API key de este dominio',
      apiKeyHint: 'Solo escritura; tras guardar solo se muestran los últimos 4 caracteres',
      apiKeyEditHint: 'Vacío = mantener la key actual (key-••••••••{{tail}}); rellenar = reemplazarla',
      status: 'Estado'
    },

    status: {
      enabled: 'Habilitado',
      disabled: 'Deshabilitado'
    },

    button: {
      create: 'Agregar dominio',
      edit: 'Editar',
      delete: 'Eliminar',
      replaceKey: 'Reemplazar key',
      testConnection: 'Probar conexión',
      testing: 'Probando...',
      save: 'Guardar',
      cancel: 'Cancelar'
    },

    modal: {
      createTitle: 'Agregar dominio de envío',
      editTitle: 'Editar dominio de envío',
      replaceKeyTitle: 'Reemplazar Sending API Key'
    },

    validation: {
      sendDomainRequired: 'Ingrese el dominio de envío',
      sendDomainInvalid: 'Ingrese un dominio válido, ej. mail.newbrand.com',
      regionRequired: 'Seleccione una región',
      apiKeyRequired: 'Ingrese la Sending API Key'
    },

    confirm: {
      delete: '¿Eliminar este dominio de envío?',
      enable: '¿Habilitar este dominio de envío?',
      disable: '¿Deshabilitar este dominio de envío? Sus remitentes no podrán enviar.',
      okText: 'Aceptar',
      cancelText: 'Cancelar'
    },

    message: {
      queryFailed: 'Consulta fallida',
      createSuccess: 'Creado correctamente',
      createFailed: 'No se pudo crear',
      updateSuccess: 'Actualizado correctamente',
      updateFailed: 'No se pudo actualizar',
      deleteSuccess: 'Eliminado correctamente',
      deleteFailed: 'No se pudo eliminar',
      statusUpdateSuccess: 'Estado actualizado correctamente',
      statusUpdateFailed: 'No se pudo actualizar el estado',
      testSuccess: 'Conexión correcta (verificada por el backend; la key nunca se devuelve)',
      testFailed: 'Conexión fallida, verifique el dominio, la región y la API key'
    }
  },
};
